import { Button, Typography } from '@scaleaq/scaleui';
import { AddOrUpdatePresetRequest } from '@scaleaq/sitecontrol-lib';
import { Control } from 'react-hook-form';

import { ControlledTextOrNumberField } from '@/components';

type PositionAxisName = keyof Pick<AddOrUpdatePresetRequest, 'distance' | 'depth' | 'pan' | 'tilt'>;

type PositionEntryProps = {
  actualAriaLabel: string;
  actualText: string;
  applyDisabled: boolean;
  applyLabel: string;
  control: Control<AddOrUpdatePresetRequest>;
  decimals: number;
  label: string;
  name: PositionAxisName;
  onApply: () => void;
  unitSuffix: string;
};

export const PositionEntry = ({
  actualAriaLabel,
  actualText,
  applyDisabled,
  applyLabel,
  control,
  decimals,
  label,
  name,
  onApply,
  unitSuffix,
}: PositionEntryProps) => (
  <>
    <Typography type='body_medium' weight={600}>
      {label}
    </Typography>
    <ControlledTextOrNumberField
      control={control}
      name={name}
      inputType='number'
      inForm={false}
      decimals={decimals}
      width='100%'
      suffix={unitSuffix}
      aria-label={label}
    />
    <Typography
      type='body_medium'
      aria-label={actualAriaLabel}
      secondary={true}
      style={{ justifySelf: 'center' }}
    >
      {actualText}
    </Typography>
    <Button
      label={applyLabel}
      variant='ghost'
      size='small'
      disabled={applyDisabled}
      onClick={onApply}
    />
  </>
);
